import ParametricsWrapper from "@televet/televet-api-middleware/src/wrappers/parametrics.wrapper";

const phw = new ParametricsWrapper();

export const GetProvince = async (userToken) => await phw.getProvince(userToken);

export const GetLocation = async (userToken, provinceId) => await phw.getLocationByProvince(userToken, provinceId);
